import { useFetchUserActivitiesProps } from "hooks/api/userProvidencesApiHooks";
import { api } from "../api";

export const getUserProvidences = async ({
  providencesFilter,
  includeAllActivities,
  userId,
}: Omit<useFetchUserActivitiesProps, "searchValue">) => {
  let url = "/userProvidences";

  let providenceStr: string | undefined = undefined;
  if (providencesFilter && providencesFilter.length > 0) {
    providenceStr = providencesFilter.join(",");
  }

  return await api.get(url, {
    params: { providenceIds: providenceStr, includeAllActivities, userId },
  });
};

export const updateActivityStatus = async (projectId, providenceStatus, user, date) => {
  let url = `/userProvidences/finish/${projectId}`;

  return await api.post(url, {
    providenceStatus: providenceStatus,
    user: user,
    date: date,
  });
};

export const updateStartedActivity = async (historyProvidenceId, userName) => {
  let url = `/userProvidences/start/${historyProvidenceId}`;

  return await api.post(url, {
    userName,
  });
};

export const updateCanceledActivity = async (historyProvidenceId) => {
  let url = `/userProvidences/cancel/${historyProvidenceId}`;

  return await api.post(url);
};

export const updateFinishedActivity = async (
  projectId,
  historyProvidenceId,
  historyStageId,
  nextDeadline,
  nextStage,
  nextProvidence,
  note
) => {
  let url = `/userProvidences/finish/${projectId}`;

  return await api.post(url, {
    historyProvidenceId: historyProvidenceId,
    historyStageId: historyStageId,
    nextDeadline: nextDeadline,
    nextStageId: nextStage,
    nextProvidenceId: nextProvidence,
    note: note,
  });
};
